/**
 * The corrections display-mode filter shared by the Data Explorer and the batch
 * Data tab. Three modes: raw DB values, DB + approved corrections (the
 * effective figures), or everything including pending proposals. The value
 * lives in the `?corr=` URL param (URL is state of record) — the pages own the
 * param read/write; this is just the control.
 */
import { SegmentedControl, Tooltip } from "@mantine/core";
import type { CorrectionDisplayMode } from "./correctionOverlay";

export function CorrectionModeControl({
  value,
  onChange,
}: {
  value: CorrectionDisplayMode;
  onChange: (mode: string) => void;
}) {
  return (
    <Tooltip
      label="Corrections overlay: DB only shows the stored values; Approved overlays approved corrections (red — the effective values); All also flags pending proposals (yellow — not applied). This is a view of the series: the batch totals shown elsewhere come from the last recompute."
      multiline
      w={300}
      withArrow
    >
      <SegmentedControl
        size="xs"
        value={value}
        onChange={onChange}
        data={[
          { value: "db", label: "DB only" },
          { value: "approved", label: "Approved" },
          { value: "all", label: "All corrections" },
        ]}
      />
    </Tooltip>
  );
}
